import { useState } from "react";

export default function LoginLayout({ children, login }) {
  const {
    showSuccess,
    errorMsg, setErrorMsg,
    successMsg, setSuccessMsg,
    showForgot,
    step,
    fpEmail, setFpEmail,
    fpOtp, setFpOtp,
    fpNewPass, setFpNewPass,
    fpConfirmPass, setFpConfirmPass,
    processing, timer, formatTime,
    sendOtp, verifyOtp, resetPassword,
    setShowForgot
  } = login;

  // 👁️ Show/hide password toggles
  const [showNewPass, setShowNewPass] = useState(false);
  const [showConfirmPass, setShowConfirmPass] = useState(false);

  return (
    <div className="dr-login-wrapper">

      {/* ===== ERROR / SUCCESS TOAST ===== */}
      {errorMsg && (
        <div className="dr-toast dr-toast-error dr-toast-autohide" onClick={() => setErrorMsg("")}>
          <span className="dr-toast-icon">⚠️</span>
          <span className="dr-toast-text">{errorMsg}</span>
          <button className="dr-toast-close" onClick={() => setErrorMsg("")}>&times;</button>
        </div>
      )}

      {successMsg && (
        <div className="dr-toast dr-toast-success dr-toast-autohide" onClick={() => setSuccessMsg("")}>
          <span className="dr-toast-icon">✅</span>
          <span className="dr-toast-text">{successMsg}</span>
          <button className="dr-toast-close" onClick={() => setSuccessMsg("")}>&times;</button>
        </div>
      )}

      {/* LEFT */}
      <div className="dr-left-section">
  <div className="dr-logo-box">
    <img src="/logo.png" alt="Suryojasvi Logo" className="dr-logo" />
    <p className="dr-logo-text">BRIGHT VISION</p>
  </div>
</div>


      {/* RIGHT */}
      <div className="dr-right-section">
        <div className="dr-login-card">
          {children}
        </div>
      </div>

      {/* SUCCESS POPUP - UPDATED FOR BETTER VISIBILITY */}
      {showSuccess && (
        <div className="dr-success-popup">
          <div className="dr-success-box">
            <div className="success-content">
              <span className="success-check">✓</span>
              <span className="success-text">Login Successful</span>
            </div>
          </div>
        </div>
      )}

      {/* ===========================
            FORGOT PASSWORD POPUP
         =========================== */}
      {showForgot && (
        <div className="dr-forgot-popup">
          <div className="dr-forgot-box">

            {/* HEADER */}
            <div className="dr-forgot-header">
              <h3>Forgot Password</h3>
              <button
                className="dr-forgot-close"
                onClick={() => setShowForgot(false)}
              >
                ×
              </button>
            </div>

            {/* STEP INDICATOR */}
            <div className="dr-step-indicator">
              <div className={`dr-step ${step === 1 && "active"}`}>
                <div className="dr-step-number">1</div>
                <span className="dr-step-label">Email</span>
              </div>

              <div className={`dr-step-line ${step >= 2 && "active"}`}></div>

              <div className={`dr-step ${step === 2 && "active"}`}>
                <div className="dr-step-number">2</div>
                <span className="dr-step-label">OTP</span>
              </div>

              <div className={`dr-step-line ${step === 3 && "active"}`}></div>

              <div className={`dr-step ${step === 3 && "active"}`}>
                <div className="dr-step-number">3</div>
                <span className="dr-step-label">Reset</span>
              </div>
            </div>

            {/* STEP 1 - EMAIL */}
            {step === 1 && (
              <div className="dr-step-content">
                <input
                  className="dr-forgot-input"
                  placeholder="Enter your registered email"
                  value={fpEmail}
                  onChange={(e) => setFpEmail(e.target.value)}
                />

                <button
                  className="dr-action-btn"
                  onClick={sendOtp}
                  disabled={processing}
                >
                  {processing ? "Sending..." : "Send OTP"}
                </button>
              </div>
            )}

            {/* STEP 2 - OTP */}
            {step === 2 && (
              <div className="dr-step-content">
                <input
                  className="dr-forgot-input"
                  placeholder="Enter OTP"
                  value={fpOtp}
                  onChange={(e) => setFpOtp(e.target.value)}
                />

                {timer > 0 && (
                  <p className="dr-timer">
                    OTP expires in <strong>{formatTime(timer)}</strong>
                  </p>
                )}

                <button
                  className="dr-action-btn"
                  onClick={verifyOtp}
                  disabled={processing}
                >
                  {processing ? "Verifying..." : "Verify OTP"}
                </button>
              </div>
            )}

            {/* STEP 3 - RESET PASSWORD */}
            {step === 3 && (
              <div className="dr-step-content">
                <div style={{ position: "relative" }}>
                  <input
                    type={showNewPass ? "text" : "password"}
                    className="dr-forgot-input"
                    placeholder="New Password"
                    value={fpNewPass}
                    onChange={(e) => setFpNewPass(e.target.value)}
                    style={{ paddingRight: "42px" }}
                  />
                  <button
                    type="button"
                    onClick={() => setShowNewPass(p => !p)}
                    style={{
                      position: "absolute", right: "12px", top: "50%",
                      transform: "translateY(-50%)", background: "none",
                      border: "none", cursor: "pointer", fontSize: "18px",
                      color: "#888", padding: 0, lineHeight: 1
                    }}
                    tabIndex={-1}
                  >
                    {showNewPass ? "🙈" : "👁️"}
                  </button>
                </div>

                <div style={{ position: "relative" }}>
                  <input
                    type={showConfirmPass ? "text" : "password"}
                    className="dr-forgot-input"
                    placeholder="Confirm Password"
                    value={fpConfirmPass}
                    onChange={(e) => setFpConfirmPass(e.target.value)}
                    style={{ paddingRight: "42px" }}
                  />
                  <button
                    type="button"
                    onClick={() => setShowConfirmPass(p => !p)}
                    style={{
                      position: "absolute", right: "12px", top: "50%",
                      transform: "translateY(-50%)", background: "none",
                      border: "none", cursor: "pointer", fontSize: "18px",
                      color: "#888", padding: 0, lineHeight: 1
                    }}
                    tabIndex={-1}
                  >
                    {showConfirmPass ? "🙈" : "👁️"}
                  </button>
                </div>

                <button
                  className="dr-action-btn"
                  onClick={resetPassword}
                  disabled={processing}
                >
                  {processing ? "Resetting..." : "Reset Password"}
                </button>
              </div>
            )}

            {/* FOOTER */}
            <div className="dr-forgot-footer">
              <button
                className="dr-cancel-btn"
                onClick={() => setShowForgot(false)}
              >
                Cancel
              </button>
            </div>

          </div>
        </div>
      )}
    </div>
  );
}